import { render, staticRenderFns } from "./InfoTextEmphasized.vue?vue&type=template&id=4342986b&scoped=true&"
import script from "./InfoTextEmphasized.vue?vue&type=script&lang=js&"
export * from "./InfoTextEmphasized.vue?vue&type=script&lang=js&"
import style0 from "./InfoTextEmphasized.vue?vue&type=style&index=0&id=4342986b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4342986b",
  null
  
)

export default component.exports